<script>

import PerPageSelect from "@/components/ui/PerPageSelect.vue";

export default {
    components: {PerPageSelect},
    data() {
        return {
            loading: {
                employer: true,
                employees: true
            },
            employer: null,
            employees: [],
            meta: {
                current_page: 1,
                total: 0,
                per_page: 0,
            },
            sort: {
                field: 'id',
                order: 'desc'
            },
            controller: {
                employer: null,
                employees: null
            },
            perPage: parseInt(localStorage.getItem('perPage_employerDetails') || '10'),
        }
    },
    methods: {
        loadData() {
            this.loading.employer = true;
            this.controller.employer = new AbortController();
            axios.get('/users/' + this.$route.params.id, {
                signal: this.controller.employer.signal,
            }).then(response => {
                this.employer = response.data.data;
            }).catch(() => {
            }).finally(() => {
                this.loading.employer = false;
            })
        },
        loadEmployees() {
            this.loading.employees = true;
            this.controller.employees = new AbortController();
            axios.get('/users/employees', {
                signal: this.controller.employees.signal,
                params: {
                    employer_id: this.$route.params.id,
                    page: this.meta.current_page,
                    per_page: this.perPage,
                    sort: this.sort.field,
                    order: this.sort.order
                }
            })
                .then(response => {
                    this.employees = response.data.data;
                    this.meta.current_page = response.data.meta.current_page;
                    this.meta.total = response.data.meta.total;
                    this.meta.per_page = response.data.meta.per_page;
                }).catch(error => {
            })
                .finally(() => {
                    this.loading.employees = false;
                })
        },
        onPageChange(page) {
            this.controller.employees.abort();
            this.meta.current_page = page;
            this.loadEmployees();
        },
        onSort(field, order) {
            this.controller.employees.abort();
            this.sort = {field, order};
            this.loadEmployees();
        },
        onPerPageChange() {
            localStorage.setItem('perPage_employerDetails', String(this.perPage));
            this.meta.current_page = 1;
            this.loadEmployees();
        },
    },
    mounted() {
        this.loadData();
        this.loadEmployees();
    },
    beforeUnmount() {
        this.controller.employees.abort();
        this.controller.employer.abort();
    }
}

</script>
<template>
    <section>
        <loader :loading="loading.employer"></loader>

        <div v-if="employer">
            <h2 class="is-3 title block">{{ employer.company.name }}</h2>
            <div class="block">
                <p>{{ employer.company.address }}, {{ employer.company.city }}</p>
                <p>{{ $t('companies.fields.nip.name') }}: <b>{{ employer.company.nip }}</b></p>
                <p>{{ $t('users.fields.token_balance.name') }}: <b>{{ employer.token_balance }}</b></p>
            </div>

            <div class="section-title is-size-5 is-uppercase">
                {{ $t('employees.labels.employees_list') }}
            </div>

            <b-table
                :data="loading.employees ? [] : employees"
                :loading="loading.employees"

                :paginated="!loading.employees && meta.total > perPage"
                backend-pagination
                :total="loading.employees ? 0 : meta.total"
                :per-page="perPage"
                @page-change="onPageChange"
                :aria-next-label="$t('navigation.next_page')"
                :aria-previous-label="$t('navigation.previous_page')"
                :aria-page-label="$t('navigation.page')"
                :aria-current-label="$t('navigation.current_page')"

                backend-sorting
                sort-icon="arrow-up"
                default-sort-direction="asc"
                :default-sort="['last_name', 'asc']"
                @sort="onSort">

                <b-table-column field="first_name" :label="$t('users.fields.first_name.name')" sortable v-slot="props">
                    {{ props.row.first_name }}
                </b-table-column>

                <b-table-column field="last_name" :label="$t('users.fields.last_name.name')" sortable v-slot="props">
                    {{ props.row.last_name }}
                </b-table-column>

                <b-table-column field="email" :label="$t('users.fields.email.name')" sortable v-slot="props">
                    {{ props.row.email }}
                </b-table-column>

                <b-table-column field="token_balance" :label="$t('users.fields.token_balance.name')" sortable v-slot="props">
                    {{ props.row.token_balance }}
                </b-table-column>

                <template #empty>
                    <div v-if="!loading.employees" class="block has-text-grey has-text-centered mb-4 mt-4">
                        {{ $t('employees.labels.no_employees') }}
                    </div>
                </template>


                <template #bottom-left>
                    <PerPageSelect v-model="perPage" @change="onPerPageChange" />
                </template>

            </b-table>

            <loader :loading="loading.employees"></loader>
        </div>
    </section>
</template>
